import { useState } from 'preact/hooks';
import { useTooltipControlled } from '../hooks/UNSAFE_useTooltip';

type Props = {
  isReadonly?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
};

export function useRatingTooltip({ isReadonly, isDisabled, tooltip }: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const text = isReadonly && !isDisabled ? tooltip : '';

  const { tooltipContent, tooltipProps } = useTooltipControlled({
    text,
    isOpen,
    anchor: {
      x: 'element',
      y: 'element'
    },
    position: 'bottom',
    offset: {
      mainAxis: 8, // redwood tooltip design spec
      crossAxis: 0
    },
    isDisabled,
    onToggle: ({ value }) => setIsOpen(value),
    variant: 'tooltip'
  });

  return {
    tooltipContent,
    tooltipProps:
      !isDisabled && isReadonly
        ? tooltipProps
        : {
            'aria-describedby': undefined
          }
  };
}
